import { Theme } from '@theme/base';
import { withTheme } from '@emotion/react';
import React from 'react';
import { BaseHero, ImageContainer } from '@components/common/hero/base/BaseHero';
import styled from '@emotion/styled';
import { NavBarContainer } from '@components/navigation';
import { PageProps } from '@model/pages';
import { TripTypes } from '@model/contentful';
import { TestId } from '@components/test-ids';
import SearchTabsBar from '@components/search/SearchTabsBar';
import { mq } from '@styles/breakpoints';

/* ***************** *
 *       Types       *
 * ***************** */
export interface DestinationHeroProps extends PageProps {
  theme?: Theme;
  src?: string;
  tripType?: TripTypes;
  promoBannerTripType?: TripTypes;
}

const LimitedHeightHero = styled(BaseHero)({
  height: '50vh',
  [ImageContainer as any]: {
    paddingBottom: '50vh',
    position: 'absolute'
  },
  [mq.small]: {
    height: '50vh'
  }
});

export const DestinationHeroComponent = ({ src, promoBannerTripType }: DestinationHeroProps) => {
  return (
    <>
      <NavBarContainer promoBannerTripType={promoBannerTripType} renderSearch={<SearchTabsBar condensed />} />
      <LimitedHeightHero testId={TestId.destinationHero} src={src} loading={'eager'} />
    </>
  );
};

export const DestinationHero = withTheme(DestinationHeroComponent);
